module.exports = __webpack_public_path__ + "static/media/failed-capture-six.513b6342.png";